import axios from 'axios';

export type BeneficiaryType = 'adult' | 'child' | 'other';
export type SubmitterSourceType = 'father' | 'mother' | 'spouse' | 'other';

export interface ParentDto {
  name?: string;
  address?: string;
  city?: string;
  idNumber?: string;
  birthDate?: string;
  isForeignResident: boolean;
}

export interface SpouseDto {
  name?: string;
  address?: string;
  city?: string;
  idNumber?: string;
  birthDate?: string;
  isForeignResident: boolean;
}

export interface SubmitterDto {
  sourceType: SubmitterSourceType;
  name?: string;
  relationship?: string;
  idNumber?: string;
  address?: string;
  city?: string;
}

export interface LeadSigningDetailsDto {
  id: number;
  benefitType: number;
  beneficiaryType: BeneficiaryType;
  clientAddress?: string;
  clientCity?: string;
  clientIdNumber?: string;
  clientBirthDate?: string;
  isClientForeignResident: boolean;
  father: ParentDto;
  mother: ParentDto;
  spouse: SpouseDto;
  submitter: SubmitterDto;
}

export const leadSigningApi = {
  get: async (leadId: number): Promise<LeadSigningDetailsDto> => {
    const response = await axios.get<LeadSigningDetailsDto>(`/leads/${leadId}/signing-details`);
    return response.data;
  },
  update: async (leadId: number, dto: LeadSigningDetailsDto): Promise<LeadSigningDetailsDto> => {
    const response = await axios.put<LeadSigningDetailsDto>(`/leads/${leadId}/signing-details`, dto);
    return response.data;
  },
};

export const emptyParent = (): ParentDto => ({ isForeignResident: false });
export const emptySpouse = (): SpouseDto => ({ isForeignResident: false });
export const emptySubmitter = (): SubmitterDto => ({ sourceType: 'other' });
